//生成候选人信息卡片数据
const transformCandidateData = (data, type) => {
  // type 0-待筛选页面 1-已筛选页面
  if (type === 0) {
    return data.map((v) => format(v, type));
  } else {
    return [format(data)];
  }
};

function format(item, type) {
  const {
    gender, //性别
    uname,
    age,
    city_name,
    city_list = [],
    work_years,
    answer_list = [],
    order_id,
    recommend_filter,
    education,
    head_portrait,
  } = item;

  let workYears = "";
  let ageStr = "";
  let sex = "";
  let genderStr = "";

  workYears = work_years && `${Math.round(work_years)}年经验`;
  ageStr = age && `${age}岁`;
  genderStr = gender ? (genderStr === "未知" ? "" : genderStr) : "";

  let cityName = "";
  // 针对待/已筛选页面对不同接口数据做处理
  if (type === 0) {
    cityName = city_name;
  } else {
    cityName = city_list.map((v) => v.data_value).join(" · ");
  }

  let baseInfoArr = [genderStr, ageStr, cityName, workYears, education];
  let baseInfo = baseInfoArr.filter((v) => v).join(" · ");

  return {
    name: uname,
    baseInfo,
    answer_list,
    order_id,
    recommend_filter,
    head_portrait,
  };
}

// function getUserName(type, name) {
//   if (!name) {
//     name = "*";
//   }
//   if (type == "男") {
//     return name.substr(0, 1) + "先生";
//   } else if (type == "女") {
//     return name.substr(0, 1) + "女士";
//   } else {
//     return name.substr(0, 1) + "**";
//   }
// }

export { transformCandidateData };
